/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  // useMaterialReactTable,
} from "material-react-table";
// import DatePicker from "react-datepicker";
import axios from "axios";
import BASE_URL from "./auth/Baseurl";
import { useNavigate } from "react-router-dom";
import ViewReview from "./ViewReview";
import ReplyReview from "./ReplyReview";
import Swal from "sweetalert2";
import { axiosInstanceWithToken } from "../helpers/axios";
const ReviewR = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isOpen2, setIsOpen2] = useState(false);

  const [loading, setLoading] = useState(true);
  const [activeButton, setActiveButton] = useState("GUEST_TO_BOOKING");


  useEffect(() => {
    Swal.fire({
      icon: "info",
      text: "Please scroll right and left to view more columns.",
      showConfirmButton: true,
    })

  }, []);

  useEffect(() => {
    let url = `/review?type=${activeButton}`;

    setLoading(true);
    if (activeButton === "HOST_TO_GUEST") {
      url += `&guest_id=${JSON.parse(localStorage.getItem('data')).id}`
    } else {
      url += `&host_id=${JSON.parse(localStorage.getItem('data')).id}`
    }

    axiosInstanceWithToken.get(url).then((response) => {
      if (response?.data?.status) {
        setData(response.data?.data?.reviews);
        setLoading(false);
      }
    }).catch((error) => {
      Swal.fire({
        icon: 'error',
        text: error.message,
      });
      setLoading(false);
    });
  }, [activeButton])

  const [selectedId, setSelectedId] = useState(null);

  // reply start //
  const [selectReply, setSelectReply] = useState(null);
  const [replyModal, setReplyModal] = useState(false);
  const [selectedRowStatus, setSelectedRowStatus] = useState('');
  const [sendReply, setSendReply] = useState("");

  const handleReply = (row) => {
    if (JSON.parse(row?.original?.meta_data)?.replies?.reply !== 'No Reply') {
      setSelectReply(row);
      setSelectedRowStatus(row.original.status)
      setReplyModal(true);
    } else {

    }
  };

  // reply end //
  const handleOpenModal = (row) => {
    setSelectedId(row);
    setSelectedRowStatus(row.original.status)
    setIsOpen2(true);
  };

  const columns = useMemo(
    () => {
      const baseColumns = [
        {
          accessorKey: "id",
          header: "ID",
          size: 150,
        },
        {
          accessorKey: "listing_id",
          header: "Listing ID",
          size: 150,
        },
        {
          accessorKey: "booking_id",
          header: "Booking ID",
          size: 150,
        },
        {
          accessorKey: "host.display_name",
          header: "Host",
          size: 150,
        },
        {
          accessorKey: "guest.display_name",
          header: "Guest",
          size: 150,
        },
        {
          accessorKey: "review",
          header: "Review",
          size: 150,
        },
        {
          accessorKey: "rating",
          header: "Average Rating",
          size: 150,
        },
        // Additional columns can be added here
      ];

      // Only add the "Actions" column if the activeButton is 'HOST_TO_GUEST'
      baseColumns.push({
        accessorKey: "action",
        header: "Actions",
        size: 200,
        Cell: ({ row }) => (
          <label className="dropdown_listing">
            <select
              className="shadow-md bg-white cursor-pointer p-[10px] rounded border-soft"
              onChange={(e) => {
                const action = e.target.value;
                if (action === "view") {
                  handleOpenModal(row);
                } else if (action === "reply") {
                  const metaData = JSON.parse(row?.original?.meta_data);
                  const reply = metaData?.replies?.reply;

                  if (reply) {
                    Swal.fire({
                      icon: "info",
                      text:
                        reply === "No Reply"
                          ? "You have already chosen to not reply, and this was a final action."
                          : "You can only reply to a review one time.",
                    });
                  } else if (reply !== "No Reply") {
                    handleReply(row);
                    setSelectedId(row);
                  }
                }
              }}
              defaultValue=""
            >
              <option value="" disabled>
                Actions
              </option>
              <option value="view">View</option>
              {(activeButton === "GUEST_TO_BOOKING") && <option value="reply">Reply</option>}
            </select>
          </label>
        ),
      });


      return baseColumns;
    },
    [activeButton, navigate]
  );


  const handleSubmit = async () => {
    if (selectedId?.original?.status === "New") {
      const review = new FormData();
      review.append("status", "Pending");
      review.append("booking_id", selectedId?.original?.booking_id);
      try {
        const response = await axios.post(
          `${BASE_URL}/booking-review`,
          review,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        fetchData();
        setIsOpen2(false);
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: err?.response?.data?.message,
        });
        setIsOpen2(false);
      }
    } else {
      fetchData();
      setIsOpen2(false);
    }
  };

  const handleSubmitReply = async () => {
    if (!selectedId?.original?.status === "Replied") {
      if (!sendReply) {
        Swal.fire({
          icon: "info",
          text: "Please reply to the review",
        });
        setReplyModal(false);
        return;
      }
      const review = new FormData();

      review.append("status", "Replied");
      review.append(
        "booking_id",
        selectReply?.original?.booking_id || selectedId?.original?.booking_id
      );
      review.append("reply", sendReply);
      try {
        const response = await axios.post(
          `${BASE_URL}/booking-review`,
          review,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire({
          position: "center",
          html: `
                <div style="display: flex; flex-direction: column; align-items: center;">
     <svg
                  viewBox="0 0 1024 1024"
                  height="4em"
                  width="4em"
                  style="margin-bottom: 10px;"
              >
                  <!-- Outer circle with color #8ec639 -->
                  <path fill="#8ec639" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
                  
                  <!-- Check mark with color #A2c66b -->
                  <path fill="#A2c66b" d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" />
              </svg>
                    <p style="margin: 0; font-size: 1.2em;">Reply submitted successfully.</p>
                </div>
            `,
          showConfirmButton: true,
          // timer: 1500  // Close after 1.5 seconds
        });
        fetchData();
        setReplyModal(false);
        {
          isOpen2 && setIsOpen2(false);
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: err?.response?.data?.message,
        });
        setReplyModal(false);
      }
    } else {
      setReplyModal(false);
      {
        isOpen2 && setIsOpen2(false);
      }
    }
  };

  // const handleNoReply = async (row) => {
  //   const review = new FormData();
  //   console.log(row.original.status, "checkingStatus");

  //   if (row?.original?.status === "Replied") {
  //     review.append("status", row?.original?.status);
  //   } else {
  //     review.append("status", "No Reply");
  //   }
  //   review.append("booking_id", row?.original?.booking_id);
  //   try {
  //     const response = await axios.post(`${BASE_URL}/booking-review`, review, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });
  //     Swal.fire({
  //       position: "center",
  //       html: `
  //                   <div style="display: flex; flex-direction: column; align-items: center;">
  //        <svg
  //                     viewBox="0 0 1024 1024"
  //                     height="4em"
  //                     width="4em"
  //                     style="margin-bottom: 10px;"
  //                 >
  //                     <!-- Outer circle with color #8ec639 -->
  //                     <path fill="#8ec639" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />

  //                     <!-- Check mark with color #A2c66b -->
  //                     <path fill="#A2c66b" d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" />
  //                 </svg>
  //                       <p style="margin: 0; font-size: 1.2em;">You have chosen to not reply.</p>
  //                   </div>
  //               `,
  //       showConfirmButton: true,
  //     });
  //     fetchData();
  //   } catch (err) {
  //     console.log(err);
  //     Swal.fire({
  //       icon: "error",
  //       text: err?.response?.data?.message,
  //     });
  //   }
  // };

  // const [roleCheck, setRoleCheck] = useState("");

  // const handleSortChange = (e) => {
  //   setRoleCheck(e.target.value);
  // };

  return (
    <>
      {replyModal && (
        <ReplyReview
          setSendReply={setSendReply}
          selectedId={selectedId}
          replyModal={replyModal}
          setReplyModal={setReplyModal}
          selectedRowStatus={selectedRowStatus}
          selectReply={selectReply}
          handleSubmitReply={handleSubmitReply}
        />
      )}
      {isOpen2 && (
        <ViewReview
          isOpen2={isOpen2}
          setIsOpen2={setIsOpen2}
          selectedId={selectedId}
          handleSubmit={handleSubmit}
          selectedRowStatus={selectedRowStatus}
          handleSubmitReply={handleSubmitReply}
          setSendReply={setSendReply}
          type={activeButton}
        />
      )}

      <div className="px-4 col-md-12">
        <div className="dashboard-title">
          <h3>Reviews</h3>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "10px",
            paddingBottom: "30px",
          }}
        >
          <button
            className={`listing_btn w-full sm:w-[120px] text-center truncate ${activeButton === "GUEST_TO_BOOKING" ? "active" : ""
              }`}
            onClick={() => setActiveButton("GUEST_TO_BOOKING")}

          >
            My Reviews
          </button>
          <button
            className={`listing_btn  w-full sm:w-[120px] text-center truncate ${activeButton === "HOST_TO_GUEST" ? "active" : ""
              }`}
            onClick={() => setActiveButton("HOST_TO_GUEST")}
          >
            Guest Reviews
          </button>
        </div>

        {loading ?
          <div className="flex flex-col items-center justify-center h-screen gap-5">
            <img
              className="h-auto w-36 md:w-44" // Responsive sizes
              src="/image/fly-inn-logo.svg"
              alt="Fly Inn Logo"
            />
            <div className="text-2xl text-bold"> Please Wait while we load your data!</div>
          </div>
          :
          <MaterialReactTable
            columns={columns}
            data={data}
            muiPaginationProps={{
              rowsPerPageOptions: [
                { value: 10, label: "10" },
                { value: 25, label: "25" },
                { value: 50, label: "50" },
                { value: 100, label: "100" },
                { value: data?.length, label: "All" },
              ],
              showFirstButton: false,
              showLastButton: false,
            }}
          />
        }

      </div>
    </>
  );
};

export default ReviewR;
